var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spotlight-image",style:({ backgroundImage: ("url(" + (_vm.file.url) + ")")})},[_c('img',{staticClass:"spotlight-image__img",attrs:{"src":"file.url","alt":_vm.file.name}})])}
var staticRenderFns = []

export { render, staticRenderFns }